import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-settings");
      setSettings(data);
    } catch (e) { /* ignore — fall back to defaults in components */ }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return (
    <SiteSettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  return ctx?.settings || {};
}

export function useRefreshSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  return ctx?.refresh || (() => {});
}
